module.exports = __webpack_public_path__ + "static/media/petri-dish-4.dc83045d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/petri-dish-4.png
// module id = 141
// module chunks = 0